import React, {useState, useEffect} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";
import Select from "react-select";


import {jobHistoryProvider} from "../../../providers/configuration/jobHistoryProvider";


const ActionsAndJobs = ({
    action= null,
    job = null,
    assignValue = (v, t) => {}
}) => {
    const [actions, setActions] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading ] = useState(false);

    useEffect(() => {
        getOptions();
    }, []);

    const getOptions =  () => {
        setLoading(true);

        jobHistoryProvider.getOptions()
            .then( result => {
                const [jobs, actions] = result;
                setActions(actions)
                setJobs(jobs)
            })
            .catch( error => console.error(error))
            .finally(_=> setLoading(false));
    }

    return <Row>
        <Col md="3">
            <FormGroup>
                <Label>Job:</Label>
                <Select
                    options={ jobs }
                    value={ job }
                    onChange={ v => assignValue(v, 'job') }
                    isLoading={ loading }
                    isClearable={ true }
                />
            </FormGroup>
        </Col>
        <Col md="3">
            <FormGroup>
                <Label>Acción</Label>
                <Select
                    options={ actions }
                    value={ action }
                    onChange={ v => assignValue(v, 'action') }
                    isLoading={ loading }
                    isClearable={ true }
                />
            </FormGroup>
        </Col>
    </Row>
}

export default ActionsAndJobs